export enum AssetType {
  AssetTypeUndefined = 0,
  ChipsOnly = 1,
  TChipsOnly = 2,
  ChipsAndT = 3,
  Fpp = 4,
  Tickets = 5,
  Bonus = 6,
  VipRewardBonus = 7,
  UserRolls = 8,
  Uncleared = 10,
  Nac2 = 11
}
